import "./App.css";
import "./global.css";

import React, { PureComponent } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";

import LoginPage from "./components/LoginPage/LoginPage";
import AccountPage from "./components/AccountPage/AccountPage";

import TopBar from "./components/TopBar/TopBar";

class App extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    //basename="/certbank"

    return (
      <div style={{ height: "100vh", backgroundColor: "#eaf1f5" }}>
        <TopBar />
        <HashRouter>
          {" "}
          <Switch>
            <Route exact path="/" component={LoginPage} />

            <Route path="/my-account" component={AccountPage} />
          </Switch>
        </HashRouter>
      </div>
    );
  }
}

export default App;
